export default [
  {
    path: '/profiles',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'profiles-list' */ '@/views/profiles/List.vue')
  }, {
    path: '/profiles/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'profiles-create' */ '@/views/profiles/Create.vue')
  }, {
    path: '/profiles/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'profile-page' */ '@/views/profiles/Profile.vue')
  }
]
